import { render, staticRenderFns } from "./MedicalCardsBase.vue?vue&type=template&id=dd4d4a32"
import script from "./MedicalCardsBase.vue?vue&type=script&lang=js"
export * from "./MedicalCardsBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports